module.exports = __webpack_public_path__ + "img/cosmopolitan.73dd8528.jpg";